var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 14.2973V6.73066C36.6667 4.38066 35.6 3.43066 32.95 3.43066H26.2167C23.5667 3.43066 22.5 4.38066 22.5 6.73066V14.2807C22.5 16.6473 23.5667 17.5807 26.2167 17.5807H32.95C35.6 17.5973 36.6667 16.6473 36.6667 14.2973Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 33.0472V26.3138C36.6667 23.6638 35.6 22.5972 32.95 22.5972H26.2167C23.5667 22.5972 22.5 23.6638 22.5 26.3138V33.0472C22.5 35.6972 23.5667 36.7638 26.2167 36.7638H32.95C35.6 36.7638 36.6667 35.6972 36.6667 33.0472Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 14.2973V6.73066C17.4999 4.38066 16.4333 3.43066 13.7833 3.43066H7.04992C4.39992 3.43066 3.33325 4.38066 3.33325 6.73066V14.2807C3.33325 16.6473 4.39992 17.5807 7.04992 17.5807H13.7833C16.4333 17.5973 17.4999 16.6473 17.4999 14.2973Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 33.0472V26.3138C17.4999 23.6638 16.4333 22.5972 13.7833 22.5972H7.04992C4.39992 22.5972 3.33325 23.6638 3.33325 26.3138V33.0472C3.33325 35.6972 4.39992 36.7638 7.04992 36.7638H13.7833C16.4333 36.7638 17.4999 35.6972 17.4999 33.0472Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.49ca2dd206814306fe3e8620fdd5396e.svg";
export { ForwardRef as ReactComponent };